import axios from '../config/axios';
import {setRequestId} from '../utils/setRequestId';

export const loadOptionsByDDType = ({callback, ddType, language = 'he', params = null}) => {
  setRequestId();
  axios.get(`/translations/getDropDownItems`, {
    params: {
      ddType,
      language,
      ...params
    }
  })
    .then(result => {
      const {data} = result;
      const {data: {items}} = data;
      return callback(items);
    })
    .catch(err => {
      console.error(err);
      return callback([]);
    });
};
